/**
 * `formatWhen` (1.V-2 conventions): the one time format of the system pages. Pure; the browser's
 * zone when `timeZone` is omitted, so specs pass a zone and never rely on the host's.
 */
export function formatWhen(iso: string, timeZone?: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return new Intl.DateTimeFormat('en-US', {
    dateStyle: 'medium',
    timeStyle: 'short',
    ...(timeZone === undefined ? {} : { timeZone }),
  }).format(date);
}
